module.exports = __webpack_public_path__ + "img/military.17330c26.png";